import { GetterTree } from "vuex";
import { PaymentSystem } from "@teacherskaya/api-provider/dist/api/PaymentSystemsProvider";
import { RootState, StatePaymentSystems } from "@/store/types";
import { isDraftPaymentSystem, isTestPaymentSystem } from "@/lib/helpers/paymentSystems";

export const getters: GetterTree<StatePaymentSystems, RootState> = {
  hasSetSystem: (state): boolean => {
    return state.systems && state.systems.some(i => !isTestPaymentSystem(i) && !isDraftPaymentSystem(i));
  },
  getTestSystems: (state): PaymentSystem[] => {
    return state.systems && state.systems.filter(i => isTestPaymentSystem(i));
  },
};
